import { render } from "./low-inventory-alert.vue?vue&type=template&id=31e7010b"
import script from "./low-inventory-alert.vue?vue&type=script&lang=js"
export * from "./low-inventory-alert.vue?vue&type=script&lang=js"

import "./low-inventory-alert.vue?vue&type=style&index=0&id=31e7010b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__